import { PropertyGroupType } from "../../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.Maps.PropertyGroup.PropertyGroupType */
export { PropertyGroupType };
/** CoStar.Api.Maps.PropertyGroup.PropertyGroupSubType */
export var PropertyGroupSubType;
(function (PropertyGroupSubType) {
    PropertyGroupSubType[PropertyGroupSubType["None"] = 0] = "None";
    PropertyGroupSubType[PropertyGroupSubType["AirportRetail"] = 1] = "AirportRetail";
    PropertyGroupSubType[PropertyGroupSubType["CommunityCenter"] = 2] = "CommunityCenter";
    PropertyGroupSubType[PropertyGroupSubType["LifestyleCenter"] = 3] = "LifestyleCenter";
    PropertyGroupSubType[PropertyGroupSubType["NeighborhoodCenter"] = 4] = "NeighborhoodCenter";
    PropertyGroupSubType[PropertyGroupSubType["OutletCenter"] = 5] = "OutletCenter";
    PropertyGroupSubType[PropertyGroupSubType["PowerCenter"] = 6] = "PowerCenter";
    PropertyGroupSubType[PropertyGroupSubType["RegionalMall"] = 7] = "RegionalMall";
    PropertyGroupSubType[PropertyGroupSubType["ThemeOrFestivalCenter"] = 8] = "ThemeOrFestivalCenter";
    PropertyGroupSubType[PropertyGroupSubType["StripCenter"] = 9] = "StripCenter";
    PropertyGroupSubType[PropertyGroupSubType["SuperRegionalMall"] = 10] = "SuperRegionalMall";
    PropertyGroupSubType[PropertyGroupSubType["RegionalPrime"] = 11] = "RegionalPrime";
    PropertyGroupSubType[PropertyGroupSubType["MajorUrbanCentre"] = 12] = "MajorUrbanCentre";
    PropertyGroupSubType[PropertyGroupSubType["UrbanCentre"] = 13] = "UrbanCentre";
    PropertyGroupSubType[PropertyGroupSubType["District"] = 14] = "District";
    PropertyGroupSubType[PropertyGroupSubType["SolusUnit"] = 15] = "SolusUnit";
    PropertyGroupSubType[PropertyGroupSubType["ShoppingPark"] = 16] = "ShoppingPark";
    PropertyGroupSubType[PropertyGroupSubType["RetailPark"] = 17] = "RetailPark";
    PropertyGroupSubType[PropertyGroupSubType["LeisurePark"] = 18] = "LeisurePark";
    PropertyGroupSubType[PropertyGroupSubType["OfficePark"] = 19] = "OfficePark";
    PropertyGroupSubType[PropertyGroupSubType["IndustrialPark"] = 20] = "IndustrialPark";
})(PropertyGroupSubType || (PropertyGroupSubType = {}));
